import { SprintStatus } from "@/models"
import { Filter } from "@/models/Pageable"

export class FilterSprint extends Filter {
  q?: string
  includedStatuses?: string[]
  excludedStatuses?: string[]
  teamIds?: string[]
  allSprintsPage?: boolean
  teamName?: string
  hasActiveOrCompletedRetrospective?: boolean
  skipCurrentAndPreviousSprints?: boolean
  projectId?: string
  sortByFavorite?: boolean

  constructor(props) {
    super(props)

    this.q = props.q ?? ""
    this.includedStatuses = props.includedStatuses ?? []
    this.excludedStatuses = props.excludedStatuses ?? []
    this.allSprintsPage = props.allSprintsPage ?? false
    this.teamName = props.teamName ?? ""
    this.hasActiveOrCompletedRetrospective = props.hasActiveOrCompletedRetrospective ?? undefined
    this.skipCurrentAndPreviousSprints = props.skipCurrentAndPreviousSprints ?? undefined
    this.projectId = props.projectId ?? undefined
    this.teamIds = props.teamIds ?? []
    this.sortByFavorite = props.sortByFavorite ?? undefined
  }

  getJsonObj() {
    const data = {
      q: this.q ?? "",
      includedStatuses: this.includedStatuses ?? [],
      excludedStatuses: this.excludedStatuses ?? [],
      hasActiveOrCompletedRetrospective: this.hasActiveOrCompletedRetrospective ?? undefined,
      skipCurrentAndPreviousSprints: this.skipCurrentAndPreviousSprints ?? undefined,
      projectId: this.projectId ?? undefined,
      teamIds: this.teamIds ?? [],
      sortByFavorite: this.sortByFavorite ?? undefined
    }

    return super.getJsonObj({ params: data })
  }

  static create(props) {
    return new FilterSprint(props)
  }

  static createDefault() {
    const props = {
      q: "",
      includedStatuses: [],
      excludedStatuses: [],
      teamId: "",
      allSprintsPage: false
    }

    const filter = new FilterSprint(props)
    return filter
  }
}

export class FilterSprintExtended extends Filter {
  projectId = ""
  includeMetrics = false
  includedStatuses: SprintStatus[] = []
  excludedStatuses: SprintStatus[] = []
  teamIds: string[] = []
  sortByFavorite?: boolean

  constructor(props?: Partial<FilterSprintExtended>) {
    super(props as Filter)
    if (!props) return
    Object.keys(props).forEach(field => {
      this[field] = props[field]
    })
  }

  getJsonObj() {
    const data = {
      projectId: this.projectId,
      includeMetrics: this.includeMetrics,
      includedStatuses: this.includedStatuses,
      excludedStatuses: this.excludedStatuses,
      teamIds: this.teamIds,
      sortByFavorite: this.sortByFavorite ?? undefined
    }
    return super.getJsonObj({ params: data, withoutPagination: true })
  }
}
